import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "tab-list",
  role: "tablist"
}

import TabItem, { type TabItemProps } from './internals/TabItem.vue';
import TabSeparator from './internals/TabSeparator.vue';

interface TabListProps {
	tabs: (TabItemProps & { value: string | number})[]
}

export default /*@__PURE__*/_defineComponent({
  __name: 'TabList',
  props: /*@__PURE__*/_mergeModels({
    tabs: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const modelValue = _useModel<string | number>(__props, "modelValue");


const isActive = (tab: TabItemProps & { value: string | number }) => tab.value === modelValue.value;
const onSelect = (value: string | number) => {
	modelValue.value = value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: tab.value
      }, [
        _createVNode(TabItem, {
          title: tab.title,
          "sub-text": tab.subText,
          disabled: tab.disabled,
          active: isActive(tab),
          onSelected: ($event: any) => (onSelect(tab.value))
        }, _createSlots({ _: 2 /* DYNAMIC */ }, [
          _renderList(_ctx.$slots, (_, name) => {
            return {
              name: name,
              fn: _withCtx((slotProps) => [
                _renderSlot(_ctx.$slots, name, _mergeProps({ ref_for: true }, slotProps || {}))
              ])
            }
          })
        ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "sub-text", "disabled", "active", "onSelected"]),
        (i < _ctx.tabs.length - 1)
          ? (_openBlock(), _createBlock(TabSeparator, { key: 0 }))
          : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})